import { BaseItemStore } from "../../core/BaseStore";
import type { BusinessFeedItem } from "./BusinessFeedItem";

export default class BusinessFeedItemsStore extends BaseItemStore<BusinessFeedItem> {}
